<template>
	<div id="ContentPanel" ref="contpan"
	v-bind:class="App.contentPanelOpen ? 'opened' : 'hidden'">

		<div id="relatedProductPanel"
		v-bind:class="App.relatedPanelOpen ? 'opened' : 'hidden'">

			<div id="relatedPanel_openclose"
			v-on:click="toggleRelatedPanel">
				<div class="bar"></div>
				<div class="hexa title_bold">
					<span class="closerelated"></span>
				</div>
			</div>


			<div id="relatedPanel_title" class="title_bold" v-html="App.relatedPanel.title"></div>
			<div id="relatedPanel_subtitle" class="subtitle" v-html="App.relatedPanel.subtitle"></div>

			<div id="relatedPanel_scrollable_area" ref="scrollarearelated"
			v-bind:style="{height: 'calc(100vh - ' + offsetTopRelated + 'px - 60px)'}">
				
				<div id="relatedPanel_desc" class="subtitle" v-html="App.relatedPanel.desc"
				v-bind:style="{ margin: App.relatedPanel.desc == '' ? '0 0 1em 0' : '0 0 3em 0' }"></div>
				<div id="relatedPanel_content" ref="relatedpanelcont" v-html="App.relatedPanel.contentHTML"
				v-on:click="clickContent"></div>
			</div>

		</div>


		<div id="ContentPanel_openclose"
		v-on:click="togglePanel">
			<div class="bar"></div>
			<div class="hexa title_bold">
				i
			</div>
		</div>


		<div id="ContentPanel_title" class="title_bold" v-html="App.contentPanel.title" v-bind:class="App.relatedPanelOpen ? 'faded' : 'fadin'"></div>
		<div id="ContentPanel_subtitle" class="subtitle" v-html="App.contentPanel.subtitle" v-bind:class="App.relatedPanelOpen ? 'faded' : 'fadin'"></div>

		<div id="ContentPanel_scrollable_area" ref="scrollarea"
		v-bind:style="{height: 'calc(100vh - ' + offsetTop + 'px - 60px)'}"  v-bind:class="App.relatedPanelOpen ? 'faded' : 'fadin'">
			
			<div id="ContentPanel_desc" class="subtitle" v-html="App.contentPanel.desc"
			v-bind:style="{ margin: App.contentPanel.desc == '' ? '0 0 1em 0' : '0 0 3em 0' }"></div>
			<div id="ContentPanel_content" ref="panelcont" v-html="App.contentPanel.contentHTML"
			v-on:click="clickContent"></div>
		</div>
		
		
	</div>
</template>

<script>
export default {
	name: 'ContentPanel',
	props: {
		App: Object
	},
	data : function() {
		return {
			offsetTop : 0,
			offsetTopRelated: 0
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.resize);
			this.resize();
		})





		document.addEventListener('contentPanelUpdated', () => { 
			this.resize(); 

			if(this.$refs.scrollarea != undefined)
				this.$refs.scrollarea.scrollTo(0, 0);

			if(!this.App.portrait)
				this.App.contentPanelOpen = this.App.contentPanel.contentHTML != ""
			
			
		})

		document.addEventListener('relatedPanelUpdated', () => { 
			this.resize(); 

			if(this.$refs.scrollarearelated != undefined)
				this.$refs.scrollarearelated.scrollTo(0, 0);
			
			
		})

	},
	created() {
	},
	methods : {

		resize() {
			this.getScrollableSize()
		},

		getScrollableSize(){
			if(this.$refs.scrollarea != undefined)
				this.offsetTop = this.$refs.scrollarea.offsetTop

			if(this.$refs.scrollarearelated != undefined)
				this.offsetTopRelated = this.$refs.scrollarearelated.offsetTop
		},

		toggleRelatedPanel() {
			//this.App.relatedPanelOpen = !this.App.relatedPanelOpen
			location.hash = this.App.currentNode.urlHash
			
		},

		togglePanel() {
			this.App.contentPanelOpen = !this.App.contentPanelOpen
		},

		clickContent(e) { // on click on the dynamic content panel
			console.log(e)
			// for each DOM element raycast hit


			if(e.path != undefined) {
				e.path.forEach( (pathE) => {

					// If we clicked on a video
					if(pathE.classList != undefined) {
						if(pathE.classList.contains('contentvideo')) {
							this.videolementClicked(pathE)
							return false;
						}
						else if(pathE.classList.contains('backcontent')) {
							location.hash = this.App.currentNode.urlHash;
							e.preventDefault()
							return false;
						}
						else if(pathE.classList.contains('stayput')) {
							this.App.nextLinkNoMovement = true;
							console.log("nextLinkNoMovement")
						}


					}
					

				})
			}
			else {
				if(e.srcElement.offsetParent.classList.contains('contentvideo')) {
					this.videolementClicked(e.srcElement.offsetParent)
					return false;
				}
				else if(e.srcElement.offsetParent.classList.contains('backcontent')) {
					location.hash = this.App.currentNode.urlHash;
					e.preventDefault()
					
					return false;
				}

				else if( e.srcElement.offsetParent.classList.contains('stayput')  ) {
					this.App.nextLinkNoMovement = true;
					console.log("nextLinkNoMovement")
				}
			}
			
		},

		// click on a video thumbnail, launch video panel
		videolementClicked(element) {
			var vid_url = element.getAttribute('data-url')
			
			this.App.video.src = vid_url;

			document.dispatchEvent(this.App.events.displayVideoPanel)
			
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../assets/css/contentPanel.css"></style>
<style scoped></style>
